export const SuperAdminSidebarData = [
    {
        title: "MANAGE EMPLOYEE",
        link: "manageEmployee",
        icon: "",
    },
    {
        title: "PAYROLL",
        link: "payroll",
        icon: "",
    },
    {
        title: "DEPARTMENT",
        icon: "",
        subMenu: [
            {
                title: "Add Department",
                path: "addDepartment",
                cName: "sub-nav",
                icon: "",
            },
            {
                title: "Edit / Delete Department",
                path: "editDeleteDepartment",
                cName: "sub-nav",
                icon: "",
            },
        ],
    },
    {
        title: "SUB DEPARTMENT",
        icon: "",
        subMenu: [
            {
                title: "Add Sub Department",
                path: "addSubDepartment",
                cName: "sub-nav",
                icon: "",
            },
            {
                title: "Edit / Delete Sub Department",
                path: "editDeleteSubDepartment",
                cName: "sub-nav",
                icon: "",
            },
        ],
    },
    {
        title: "DESIGNATION",
        icon: "",
        subMenu: [
            {
                title: "Add Designation",
                path: "addDesignation",
                cName: "sub-nav",
                icon: "",
            },
            {
                title: "Edit / Delete Designation",
                path: "editDeleteDesignation",
                cName: "sub-nav",
                icon: "",
            },
        ],
    },
    // {
    //     title: "ACTIVE USER",
    //     link: "activeUser",
    //     icon: "",
    // },
    {
        title: "SALARY ANALYSIS",
        link: "salaryAnalysis",
        icon: "",
    },
    {
        title: "ADD POLICY",
        link: "addPolicy",
        icon: "",
    },
    {
        title: "KRA/KPI",
        link: "addKraKpi",
        icon: "",
    },
];